import { djs } from '@duke-hq/djs';
import type { StudentWorkSchedule } from '@duke-hq/svc-api-db/client';

export function getSemesterStartDate(
  semesterNum: number,
  courseEnrolment: {
    work_schedule: StudentWorkSchedule;
    start_at_date: Date;
    semester_2_start_at_date: Date | null;
    created_at: Date;
    course_segment: string;
  },
): Date {
  // Determine the length of a semester in weeks, depending on part-time or full-time schedule
  const semesterDuration = courseEnrolment.work_schedule === 'PART_TIME' ? 2 : 1;

  const courseStartDate = djs(courseEnrolment.start_at_date);
  const semesterTwoStartDate = courseEnrolment.semester_2_start_at_date
    ? djs(courseEnrolment.semester_2_start_at_date)
    : null;

  if (semesterNum === 0) {
    return courseStartDate.isSameOrAfter(courseEnrolment.created_at, 'day')
      ? djs(courseEnrolment.created_at).toDate()
      : courseStartDate.toDate();
  }

  // For the first semester, simply return the course start date
  if (semesterNum === 1) {
    return courseStartDate.toDate();
  }
  // For the second semester, use the provided second semester start date, if available
  if (semesterNum === 2 && semesterTwoStartDate) {
    return semesterTwoStartDate.toDate();
  }

  // For additional semesters, calculate the start date based on the duration and semester number
  return courseStartDate.add(13 * semesterDuration * (semesterNum - 1), 'weeks').toDate();
}
